<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <div class="cdj_div">客户预收款变动明细表-查询条件</div>
    <div class="cdj_table">
      <div class="cdj_display">
        <div class="cdj_left">
          <div class="cdj_left_display">
            <div class="cdj_left_display_background">计费周期</div>
            <div class="cdj_el-input el-date-pickers">
              <el-date-picker size="mini" v-model="value1" type="date" placeholder="开始时间"></el-date-picker>
              <span class="cdj_text_data">至</span>
              <el-date-picker size="mini" v-model="value2" type="date" placeholder="结束时间"></el-date-picker>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">已收日期</div>
            <div class="cdj_el-input el-date-pickers">
              <el-date-picker size="mini" v-model="value1" type="date" placeholder="开始时间"></el-date-picker>
              <span class="cdj_text_data">至</span>
              <el-date-picker size="mini" v-model="value2" type="date" placeholder="结束时间"></el-date-picker>
            </div>
          </div>
        </div>
        <div class="cdj_left">
          <div class="cdj_left_display">
            <div class="cdj_left_display_background">房产范围</div>
            <div class="cdj_el-input"><el-input size="mini" v-model="search" placeholder="房产范围"></el-input></div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">查询类型</div>
            <div class="cdj_el-input"><el-input size="mini" v-model="search" placeholder="查询类型"></el-input></div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">房态状态</div>
            <div class="cdj_el-input"><el-input size="mini" v-model="search" placeholder="房态状态"></el-input></div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-bottom:1px;margin-top: 10px;">
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
      <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出</el-button>
    </div>
    <div style="display: flex;color: red;margin-top: 7px">
      <div>总金额：￥{{money}}元</div>
    </div>
    <v-divider></v-divider>
   <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">姓名</th>
              <th class="text-left">房产名称</th>
              <th class="text-left">费用周期</th>
              <th class="text-left">费用名称</th>
              <th class="text-left">金额(实收)</th>
              <th class="text-left">金额(应收)</th>
              <th class="text-left">已缴金额</th>
              <th class="text-left">状态</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
            <tr class="text1" v-for="(item,index) in desserts" :key="item.id">
              <td >{{item.h_name}}<span v-if="!item.h_name">--</span></td>
              <td >
                  {{item.h_name_date}}
              </td>
              <td >{{item.startDate}}至{{item.endDate}}</td>
              <td ><span v-if="item.charge_name">{{item.charge_name}}</span><span v-else>{{item.xsc_ChargeName}}</span></td>
              <td >{{item.charge}}</td>
              <td >{{item.chargePay}}</td>
              <td >{{item.PaidChargeSum}}</td>
              <td ><span v-if="item.state==1">待支付</span><span v-if="item.state==2">已付款</span></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
</div>

</template>

<script>
export default {
  data () {
    return {
      pid:'',
      value1:'',
      value2:'',
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      money:'--',
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      state:0,
      homeName:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    this.moneys();
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          console.log(333);
          this.$Loading.finish();
      });
    },
   //查询总欠费
   moneys(){
     this.$myhttp.post('admin/Receivables/getMoney',this.data,{
       'Content-Type': 'application/x-www-form-urlencoded'
       }).then(backdata=>{ // 异步执行成功后
         this.money = backdata.data['money'];
     });
   },
   //获得当前多少页,分页
   change(e){
     ERP.showLoading()
     this.$Loading.start();
     this.data.page = e;
     this.$myhttp.post('admin/Receivables/index',this.data,{
       'Content-Type': 'application/x-www-form-urlencoded'
       }).then(backdata=>{ // 异步执行成功后
         let data = backdata.data.data;
         this.desserts = data.data;
         this.total = data.count;
         this.page = data.pageSize;
         this.$Loading.finish();
         ERP.hideLoading()
     });
   },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    // 树组件点击触发
    nodeClick(data) {
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.pid = data.tree[0]['id'];
      // this.homeName=tree_str;
      // this.change(1);
      this.value2=4;
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.change(1);
      }
    }
  },
  watch:{

  },

  components: {
    "erp-tree": () => import('../Common/erp-tree.vue')
  },

}
</script>
<style scoped>
@import '../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/advancesUpdate.vue